import { useState } from 'react';

import { DockMenuProps } from './index.types';

export function useDockMenuController(_props: DockMenuProps) {
  const [menuAnchorEl, setMenuAnchorEl] = useState<HTMLElement | null>(null);

  const handleMenuOpen = (event: React.MouseEvent<HTMLElement>) => {
    setMenuAnchorEl(event.currentTarget);
  };

  const handleMenuClose = () => {
    setMenuAnchorEl(null);
  };
  return {
    anchorEl: menuAnchorEl,
    open: Boolean(menuAnchorEl),
    handleOpen: handleMenuOpen,
    handleClose: handleMenuClose,
  };
}
